import React from 'react';

import Label from '../../../common/Labels/Label';
import Tooltip from './D3Tooltip';

export const D3MouseoverTooltip = ({
  id,
  xScale, 
  yScale,
  tooltipPoint,
  mousePosition,
  children,
  coordOffset = { left: 0, top: -80 },
  formatLabel = (x, y) => `${x}, ${y}`,
  hideZeroValues = false,
  useMousePosition = false,
}) => {
  if (hideZeroValues && !tooltipPoint?.y) {
    return null;
  }
  
  const coords = useMousePosition && mousePosition
    ? { x: mousePosition.x, y: mousePosition.y }
    : tooltipPoint ? { x: xScale(tooltipPoint?.x), y: yScale(tooltipPoint?.y) }
      : null;

  return (
    <Tooltip
      id={id}
      left={coords ? coords.x + coordOffset.left : 0}
      top={coords ? coords.y + coordOffset.top : 0}
      isShown={coords}
    >
      {
        children || (
          tooltipPoint && (
            <Label color="white">{formatLabel(tooltipPoint.x, tooltipPoint.y)}</Label>
          )
        )
      }
    </Tooltip>
  )
}

export default D3MouseoverTooltip;
